// extracted by mini-css-extract-plugin
export var dot = "Dots-module--dot---H3e+";
export var active = "Dots-module--active--tf3f8";